/**
 * Adds navigation functionality to the "Continue shopping" button
 * inside the Recharge cart drawer's Shadow DOM
 * Uses event delegation to avoid interfering with cart state management
 * Waits for Alpine.js to initialize to prevent timing conflicts
 */
document.addEventListener('alpine:init', () => {
  const CART_DRAWER_ID = 'recharge-storefront-experiences__cart-drawer';
  const CONTINUE_SHOPPING_URL = '/collections/all';
  const MAX_RETRIES = 50; // 5 seconds max (50 * 100ms)
  let retryCount = 0;
  let listenerAttached = false;

  /**
   * Adds click handler using event delegation
   */
  function addContinueShoppingLink() {
    const rechargeCartDrawer = document.getElementById(CART_DRAWER_ID);

    if (!rechargeCartDrawer) {
      if (retryCount < MAX_RETRIES) {
        retryCount++;
        setTimeout(addContinueShoppingLink, 100);
      }
      return;
    }

    if (!rechargeCartDrawer.shadowRoot) {
      if (retryCount < MAX_RETRIES) {
        retryCount++;
        setTimeout(addContinueShoppingLink, 100);
      }
      return;
    }

    // Only attach the listener once
    if (listenerAttached) {
      return;
    }

    // Use event delegation on the shadow root
    rechargeCartDrawer.shadowRoot.addEventListener('click', function(e) {
      // Check if clicked element is a button
      const button = e.target.closest('button');

      if (button) {
        const buttonText = button.textContent.trim();

        // Check if it's the Continue Shopping button
        if (buttonText === 'Continue shopping') {
          // Navigate to the collections page
          window.location.href = CONTINUE_SHOPPING_URL;
        }
      }
    });

    listenerAttached = true;
  }

  // Initialize after Alpine.js is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(addContinueShoppingLink, 500);
    });
  } else {
    setTimeout(addContinueShoppingLink, 500);
  }
});
